import { Injectable, signal } from '@angular/core';
import { IMenuItems } from '../model/menuItems';
import { UserRole } from '../model/role';

@Injectable({
  providedIn: 'root',
})
export class Sidebarservice {
  activeMenu = signal<IMenuItems | null>(null)

  role: UserRole = UserRole.USER;

  constructor() {
    this.role = this.getRole()
  }

  getRole(): UserRole {
    const roleStr = localStorage.getItem('userRole');
    return roleStr as UserRole || UserRole.USER;
  }

  getmenuItems(): IMenuItems[] {
    this.role = this.getRole()

    const roleRoute =
      this.role === UserRole.SUPERADMIN
        ? '/superAdmin'
        : this.role === UserRole.ADMIN
          ? '/admin'
          : this.role === UserRole.TEAMMANAGER
            ? '/teamManager'
            : this.role === UserRole.VIEWER
              ? '/viewer'
              : '/user';

    return [
      {
        label: 'Dashboard',
        icon: 'dashboard',
        route: `${roleRoute}/dashboard`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.SUPERADMIN]
      },
      {
        label: 'Organizations',
        icon: 'organizations',
        route: `${roleRoute}/organizations`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.SUPERADMIN]
      },
      {
        label: 'Release',
        icon: 'release',
        route: `${roleRoute}/release`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.SUPERADMIN]
      },
      {
        label: 'Pricing Tiers',
        icon: 'pricingTiers',
        route: `${roleRoute}/pricing-tiers`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.SUPERADMIN]
      },
      {
        label: 'Settings',
        icon: 'settings',
        route: `${roleRoute}/settings`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.SUPERADMIN]
      },

      {
        label: 'Dashboard',
        icon: 'dashboard',
        route: `${roleRoute}/dashboard`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN, UserRole.TEAMMANAGER, UserRole.USER, UserRole.VIEWER]
      },

      {
        label: 'Packages',
        icon: 'package',
        route: `${roleRoute}/packages`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        // The API scopes the list to the caller's role: org admins see everything, team managers
        // only their teams' devices.
        roles: [UserRole.ADMIN, UserRole.TEAMMANAGER]
      },

      {
        label: 'Threats',
        icon: 'warning',
        route: `${roleRoute}/threats`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN]
      },

      {
        label: 'Scan Histroy',
        icon: 'history',
        route: `${roleRoute}/scanHistory`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN]
      },
      {
        label: 'Download Log',
        icon: 'download',
        route: `${roleRoute}/downloadLogs`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN, UserRole.TEAMMANAGER]
      },
      {
        label: 'Teams',
        icon: 'teams',
        route: `${roleRoute}/teams`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN]
      },
      {
        label: 'Devices',
        icon: 'device',
        route: `${roleRoute}/devices`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN]
      },
      {
        label: 'Repositories',
        icon: 'repositories',
        route: `${roleRoute}/repositories`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN]
      },
      {
        label: 'Deployments Keys',
        icon: 'key',
        route: `${roleRoute}/deploymentKeys`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN]
      },
      {
        label: 'Audit Logs',
        icon: 'auditLogs',
        route: `${roleRoute}/auditLogs`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN]
      },
      {
        label: 'Users',
        icon: 'userSettings',
        route: `${roleRoute}/users`,
        iconBgColor: 'bg-blue-500',
        iconColor: '#00d4aa',
        roles: [UserRole.ADMIN]
      }
    ];
  }
}
